<template>
  <div>
    <div class="card">
      <header class="header-card is-paddingless pd-2">
        <p>{{ $t('addEditNomenclatureType.information.schema') }}</p>
      </header>
      <div class="card-content">
        <div class="level">
          <div class="level-left"></div>
          <div class="level-right">
            <qd-button
              @click="openPopUpAddChamps = true"
              class="is-pulled-right is-addOrEdit">
              {{ $t('addEditNomenclatureType.ajouterChamps') }}
            </qd-button>
          </div>
        </div>
        <ligne-champs v-for="(property, index) in properties || []"
          :key="index"
          :property="property"
          @update:property="updateProperty($event, index)"
          @remove="checkSuprr(property)">
        </ligne-champs>
      </div>
    </div>
    <b-modal
      v-model="openPopUpPreventionSuppr"
      has-modal-card
      class="modal">
      <pop-up-prevention
        :messHeader="$t('addEditNomenclatureType.messWarning.deleteField')"
        :messDescription="$t('addEditNomenclatureType.messWarning.message')"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.valider')"
        @no="openPopUpPreventionSuppr=false"
        @yes="removeProperty(elemToDelete)"/>
    </b-modal>
    <b-modal
      v-model="openPopUpAddChamps"
      has-modal-card
      class="modal">
      <pop-up-add-champ
        v-if="openPopUpAddChamps"
        :propertiesNames="propertiesNames"
        @add="addProperty"/>
    </b-modal>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import popUpAddChamp from '@/components/parametrage/nomenclature/p_addChamp';
import ligneChamps from '@/components/parametrage/nomenclature/ligneChamps';
import popUpPrevention from '@/components/general/popUpPrevention';

import {
  TEXTE,
  TABLEAU,
} from '@/configuration/jsonEditor/jsonEditorConfig';
import convertValue from '@/services/general/typeConverter';

export default {
  props: {
    schema: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  components: {
    popUpAddChamp,
    popUpPrevention,
    ligneChamps,
  },
  data() {
    return {
      properties: null,
      openPopUpAddChamps: false,
      openPopUpPreventionSuppr: false,
      elemToDelete: null,
      constantes: {
        TEXTE,
        TABLEAU,
      },
    };
  },
  computed: {
    propertiesNames() {
      return Object.keys(this.properties);
    },
  },
  methods: {
    initializeProperties(properties) {
      const initializedProperties = {};
      Object.keys(properties).forEach((key, index) => {
        const prop = properties[key];
        const type = prop.type || this.constantes.TEXTE;
        const val = prop.defaultValue || prop.default;
        const result = {
          name: key,
          label: prop.label || key,
          type: type,
          arrayValues: prop.type === this.constantes.TABLEAU ? prop.arrayValues : [],
          propertyOrder: prop.propertyOrder || index + 1,
          defaultValue: convertValue(val, type),
        };
        initializedProperties[key] = result;
      });
      return this.sortProperties(initializedProperties);
    },
    sortProperties(properties) {
      const copy = Object.values(properties).sort((a, b) => a.propertyOrder - b.propertyOrder);
      return copy.reduce((acc, val) => {
        acc[val.name] = val;
        return acc;
      }, {});
    },
    addProperty(champs) {
      const ordres = Object.values(this.properties).map((p) => {
        return p.propertyOrder;
      });
      const ordre = ordres.length ? Math.max(...ordres) : 0;
      champs.propertyOrder = ordre + 1;
      champs.label = champs.name ?? champs.label;
      this.properties[champs.name] = champs;
      this.properties = this.sortProperties(this.properties);
      this.updateSchema();
    },
    checkSuprr(property) {
      this.elemToDelete = property;
      this.openPopUpPreventionSuppr = true;
    },
    removeProperty(property) {
      const copy = cloneDeep(this.properties);
      delete copy[property.name];
      this.properties = copy;
      this.updateSchema();
      this.openPopUpPreventionSuppr = false;
    },
    updateSchema() {
      const updatedProperties = Object.values(this.properties).reduce((acc, prop) => {
        acc[prop.name] = {
          label: prop.label,
          type: prop.type,
          propertyOrder: prop.propertyOrder,
          defaultValue: prop.defaultValue,
          arrayValues: prop.arrayValues,
        };
        return acc;
      }, {});
      this.$emit('update:schema', { ...this.schema, properties: updatedProperties });
    },
    updateProperty(updatedProperty) {
      this.properties[updatedProperty.name] = updatedProperty;
      this.updateSchema();
    },
  },
  mounted() {
    this.properties = this.initializeProperties(this.schema.properties);
  },
};
</script>
